import script from "./LandPlotModalBottom.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandPlotModalBottom.vue?vue&type=script&setup=true&lang=ts"

import "./LandPlotModalBottom.vue?vue&type=style&index=0&id=27ce7c03&lang=less"

const __exports__ = script;

export default __exports__